import { join, map, pathOr, pipe } from 'ramda'
import {
  getValidationErrors,
  hasEligibilityFulfillmentMethods,
  hasSkipCreditCheckTag,
  hasTosGuardianTag,
  isIMEIDuplicated
} from './cart'
import { hasOutOfStockItems } from './rti'

// Some validation errors display a custom error banner instead of the generic invalid
// products banner. This function filters out these custom scenarios to determine if the
// generic invalid products banner should be displayed.
const isCartValidExcludingIMEIAndRTI = (cart) => {
  if (!hasEligibilityFulfillmentMethods(cart)) return false

  const validationErrors = getValidationErrors(cart)

  // RETURN_DEVICES_DUPLICATE_IMEI_FOUND is caught in isIMEIDuplicated.
  // UNSELLABLE_ITEMS is caught in hasOutOfStockItems.
  const isNotIMEIDuplicateErrorAndNotRTIError = (error) =>
    error.message !== 'RETURN_DEVICES_DUPLICATE_IMEI_FOUND' && error.code !== 'UNSELLABLE_ITEMS'

  const cartContainsErrorsExcludingIMEIDuplicatedAndRTI = validationErrors?.some(
    isNotIMEIDuplicateErrorAndNotRTIError
  )

  return !cartContainsErrorsExcludingIMEIDuplicatedAndRTI
}

export const checkIsCartValid = ({ cart, prov, linkType }) => {
  // This error should not stack with other errors as it should be resolved first
  if (linkType === 'commerce_checkout_ineligible_mh_back_to_cart') {
    return { isValid: false, reasons: ['INELIGIBLE_MH'] }
  }

  // This error should not stack with other errors as it should be resolved first
  if (cart?.root?.province !== prov?.toUpperCase()) {
    return { isValid: false, reasons: ['PROVINCE_MISMATCH'] }
  }

  // This error should not stack with other errors as it should be resolved first.
  // Since this cart flow can only occur with just this item in cart we do not have
  // to worry about other cart item errors
  if (hasTosGuardianTag(cart) && !hasSkipCreditCheckTag(cart)) {
    return { isValid: false, reasons: ['TOS_BREACH'] }
  }

  const reasons = []

  if (hasOutOfStockItems(cart)) {
    reasons.push('OUT_OF_STOCK')
  }

  if (isIMEIDuplicated(cart)) {
    reasons.push('RETURN_DEVICES_DUPLICATE_IMEI_FOUND')
  }

  if (!isCartValidExcludingIMEIAndRTI(cart)) {
    reasons.push('INVALID_PRODUCTS')
  }

  return {
    isValid: reasons.length === 0,
    reasons
  }
}

export const buildErrorCodes = pipe(
  pathOr([], ['root', 'validationErrors']),
  map((e) => e.code),
  join(' | ')
)
